import BaseAPIService from './BaseAPIService';

export default class NewsService extends BaseAPIService {
	constructor() {
		super();
    }

    getNews() {
        return new Promise((resolve, reject) => {
			const query = require('../graphql/queries/news.gql');
			const variables = {  };
			this.query({ query, variables, fetchPolicy: 'network-only' })
				.then(result => {
					const returnData = result.data.news;
					resolve(returnData);
				})
				.catch(reject);
		});
    }
}